/**
 * Button 组件 - 基于 Ant Design Button 组件，添加自定义样式，统一UI设计规范
 */
import { Button as AntdButton } from 'antd';
import { forwardRef } from 'react';
import styles from './less/button.module.less';
import type { ButtonProps } from 'antd';

export type { ButtonProps } from 'antd';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ className, ...rest }, ref) => (
  <AntdButton ref={ref} autoInsertSpace={false} {...rest} className={[styles.button, className].filter(Boolean).join(' ')} />
));
